/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Go_To_End_TitleInputs */



/**
* | output |
* | --- |
* | "Go To End" |
*
* @param {Player_Go_To_End_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_go_to_end_title = /** @type {((inputs?: Player_Go_To_End_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Go_To_End_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aller a la Fin")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zum Ende springen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vai alla fine")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перейти к концу")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ir al final")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("前往结尾")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最後へ移動")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अंत तक जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ir para o fim")
	return /** @type {LocalizedString} */ ("Go To End")
});